<template>
  <div>
    <div id="header-outer" class="edith-bg-medium">
      <div id="header-left">
        <div id="edith-orange-header">
          <div id="edith-orange-internal">
            <img src="../../assets/Edith.png" alt="Edith Logo" height="120px" width="180px"/>
          </div>
        </div>
        <div id="patientenliste-button-header">
          <b-button variant="outline-primary" @click="backToPatientList">
            Neue Patient
          </b-button>
          <!--<b-button @click="simulateConnectionError">Simuliere Verbindungsfehler</b-button>-->
        </div>
        <div id="patient-name-header" v-if="patientData">
          <h4>Patienteninformationen</h4>
          <ul>
            <li>Geburtsjahr:
              {{ (new Date(patientData.birthDate).getFullYear()) }}
            </li>
            <li>Geschlecht: {{ genderMap[patientData.sex] }}</li>
          </ul>
        </div>
      </div>
      <div id="logout-timer-header">
        <p class="text-center" style="color: red">EDUCATION and RESEARCH ONLY! <br><span style="color: black">Es ist keine Verwendung in der Patientenversorgung erlaubt.
            Die Wissensbasis wird nicht aktualisiert!</span> </p>
      </div>
      <div id="header-right">
        <div id="button-logout-header">
          <b-button variant="outline-danger" @click="logout">
            Verwerfen
            <b-icon-trash/>
          </b-button>
        </div>

      </div>
    </div>
    <DeletionModal centered
                   :show=" deletionModalAnfaelleDisplayed"
                   :header-message="'Anfallstyperfassung wirklich abbrechen?'"
                   :subheader-message="'Bisher gemachte Eintragungen werden nicht gespeichert.'"
                   :abort-button-label="'Erfassung fortsetzen'"
                   :confirm-button-label="'Abbrechen und Daten verwerfen'"
                   @close="closeDeletionModalAnfaelle"
                   @deleteConfirm="deleteAnfall"/>
    <DeletionModal centered
                   :show="deletionModalTUDisplayed"
                   :header-message="'Technische Untersuchungerfassung wirklich abbrechen?'"
                   :subheader-message="'Bisher gemachte Eintragungen werden nicht gespeichert.'"
                   :abort-button-label="'Erfassung fortsetzen'"
                   :confirm-button-label="'Abbrechen und Daten verwerfen'"
                   :modal-size="'lg'"
                   @close="closeDeletionModalTU"
                   @deleteConfirm="deleteTU"/>
  </div>
</template>

<script>


import {localDateFormat} from "../../js/util";
import {mapGetters} from "vuex";
import DeletionModal from "../modal/DeletionModal.vue";

export default {
  name: "Header",
  components: {
    DeletionModal,
  },
  props: {
    patientData: Object
  },
  data() {
    return {
      localDateFormat: localDateFormat,
      buttonClass: 'light',
      alertClass: 'alert-light',
      deletionModalAnfaelleDisplayed: false,
      deletionModalTUDisplayed: false,
      backToPatientCalled: undefined,

      genderMap: {
        m: 'Männlich',
        w: 'Weiblich'
      }
    }
  },
  computed: {
    ...mapGetters({
      showAnfaelleOverview: 'cdss/showAnfaelleOverview',
      showUntersuchungenOverview: 'cdss/showUntersuchungenOverview',
    }),
  },
  methods: {
    backToPatientList() {
      if (this.$route.name === 'anfaelle' && this.showAnfaelleOverview === false) {
        this.backToPatientCalled = true
        this.showDeletionModalAnfaelle()
      } else if (this.$route.name === 'technische-untersuchungen' && this.showUntersuchungenOverview === false) {
        this.backToPatientCalled = true
        this.showDeletionModalTU()
      } else {
        this.$store.reset() //the store is reset in all the levels and modules
        this.$router.replace('/app/secure')
      }
    },
    closeDeletionModalAnfaelle() {
      this.deletionModalAnfaelleDisplayed = false;
      this.backToPatientCalled = undefined;
      this.logoutCalled = undefined;
    },
    deleteAnfall() {
      if (this.backToPatientCalled) {
        this.$store.dispatch('cdss/putPatientData')
            .then(() => {
              let actualExpirationTime = this.$store.state['tokenExpirationTime']
              let actualTokenValidityDuration = this.$store.state['tokenValidityDuration']
              this.$store.reset() //the store is reset in all the levels and modules
              //make sure we still have the ExpirationTime and TokenValidityDuration
              this.$store.commit('setTokenExpirationTime', actualExpirationTime)
              this.$store.commit('setTokenValidityDuration', actualTokenValidityDuration)
              this.$store.commit('cdss/setShowSavedDataFlag', true)
              this.$store.commit('cdss/setShowAnfaelleOverview', true)
              this.closeDeletionModalAnfaelle()
              this.$router.replace('/app/secure')
            })
      } else if (this.logoutCalled) {
        this.$store.commit('cdss/setShowSavedDataFlag', true)
        this.$store.commit('cdss/setShowAnfaelleOverview', true)
        this.closeDeletionModalAnfaelle()
        this.$emit('logout')
      }
    },
    showDeletionModalAnfaelle() {
      this.deletionModalAnfaelleDisplayed = true;
    },
    closeDeletionModalTU() {
      this.deletionModalTUDisplayed = false;
    },
    deleteTU() {
      if (this.backToPatientCalled) {
        this.$store.dispatch('cdss/putPatientData')
            .then(() => {
              let actualExpirationTime = this.$store.state['tokenExpirationTime']
              let actualTokenValidityDuration = this.$store.state['tokenValidityDuration']
              this.$store.reset() //the store is reset in all the levels and modules
              //make sure we still have the ExpirationTime and TokenValidityDuration
              this.$store.commit('setTokenExpirationTime', actualExpirationTime)
              this.$store.commit('setTokenValidityDuration', actualTokenValidityDuration)
              this.$store.commit('cdss/setShowSavedDataFlag', true)
              this.$store.commit('cdss/setShowUntersuchungenOverview', true)
              this.closeDeletionModalTU()
              this.$router.replace('/app/secure')
            })
      } else if (this.logoutCalled) {
        this.$store.commit('cdss/setShowSavedDataFlag', true)
        this.$store.commit('cdss/setShowUntersuchungenOverview', true)
        this.closeDeletionModalTU()
        this.$emit('logout')
      }
    },
    showDeletionModalTU() {
      this.deletionModalTUDisplayed = true;
    },
    logout() {
      if (this.$route.name === 'anfaelle' && this.showAnfaelleOverview === false) {
        this.logoutCalled = true
        this.showDeletionModalAnfaelle()
      } else if (this.$route.name === 'technische-untersuchungen' && this.showUntersuchungenOverview === false) {
        this.logoutCalled = true
        this.showDeletionModalTU()
      } else {
        this.$emit('logout')
      }
    }
  }
}
</script>

<style scoped>
#header-outer {
  display: grid;
  height: 120px;
  width: 100%;
  grid-template-areas: "left center right";
  grid-template-columns: 1fr 300px 1fr;

}

#header-left {
  grid-area: left;
  height: 100%;
  display: grid;
  grid-template-areas: "edith-orange patientenliste-button patient-name";
  grid-template-columns: minmax(80px, 180px) 150px 1fr;
  grid-column-gap: 10px;
}

#edith-orange-header {
  display: grid;
  grid-template-areas: "single";
  grid-area: edith-orange;
  text-align: center;
}

#edith-orange-internal {
  grid-area: single;
  align-self: center;
}

#patientenliste-button-header {
  align-self: center;
  grid-area: patientenliste-button;
}

#patient-name-header {
  align-self: center;
  grid-area: patient-name
}

#logout-timer-header {
  grid-area: center;
  display: grid;
  grid-template-areas: "label the-button";
  grid-template-columns: 1fr min-content;
  grid-template-rows: 1fr;

  justify-items: center;
  align-items: center;
}

#logout-timer-label {
  grid-area: label;
}

#logout-timer-button {
  grid-area: the-button;
}

#header-right {
  justify-items: right;
  grid-area: right;
  display: grid;
  grid-template-areas: "username logout";
  grid-template-columns:  min-content 1fr;
}

#label-username-header {
  justify-self: right;
  align-self: center;
  grid-area: username;
  margin-right: 10px;
}

#button-logout-header {
  align-self: center;
  grid-area: logout;
  margin-right: 10px;
}
</style>
